import NavBar from './navbar';
import NavMenu from './navmenu';
import { useAppDispatch, useAppSelector } from '../slices/index';
import * as UI from '../slices/uiSlice';
import SearchCases from './searchcases';
import * as Cases from '../slices/casesSlice';
import CaseListItem from './caselistitem';
import { AnyAction } from '@reduxjs/toolkit';
import '../App.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown, faCaretUp } from '@fortawesome/free-solid-svg-icons';
import clear_filter from '../assets/Clear_Filter.svg';
import leading_the_way from '../assets/Leading_The_Way_Conveyancing.svg';
import icon_wishlist from '../assets/Wishlist_White.svg';
import { useEffect, useState } from 'react';

const WishList = () => {
	const [wishlistCases, setWishlistCases] = useState<Cases.caseListState[]>([]);
	const cases = useAppSelector(state => state.cases);
	const dispatch = useAppDispatch();

	const actionOnClick = (item: Cases.sortType) => {
		dispatch(Cases.setSortType(item));
	}

	const handleScroll = () => {
		dispatch((UI.closeMenu()) as unknown as AnyAction);
	};

	const doTeamOnChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
		const setft = () => new Promise((resolve) => resolve(dispatch(Cases.setFilterTeam(e.target.value))));
		setft().then(() => {
			dispatch(Cases.searchCases({ searchStr: cases.searchStr, isWishlisted: true }));
		});
	}

	const doTypeOnChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
		const setft = () => new Promise((resolve) => resolve(dispatch(Cases.setFilterType(e.target.value))));
		setft().then(() => {
			dispatch(Cases.searchCases({ searchStr: cases.searchStr, isWishlisted: true }));
		});
	}

	const doSiteOnChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
		const setft = () => new Promise((resolve) => resolve(dispatch(Cases.setFilterSite(e.target.value))));
		setft().then(() => {
			dispatch(Cases.searchCases({ searchStr: cases.searchStr, isWishlisted: true }));
		});
	}

	const doStageOnChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
		const setft = () => new Promise((resolve) => resolve(dispatch(Cases.setFilterStage(e.target.value))));
		setft().then(() => {
			dispatch(Cases.searchCases({ searchStr: cases.searchStr, isWishlisted: true }));
		});
	}
	const clearFilters = () => {
		const setft = () => new Promise((resolve) => resolve(dispatch(Cases.setFilterTeam(''))));
		const setfte = () => new Promise((resolve) => resolve(dispatch(Cases.setFilterType(''))));
		const setfst = () => new Promise((resolve) => resolve(dispatch(Cases.setFilterSite(''))));
		const setfs = () => new Promise((resolve) => resolve(dispatch(Cases.setFilterStage(''))));
		const setfstatus = () => new Promise((resolve) => resolve(dispatch(Cases.setFilterStatus(['1', '2', '3', '4', '6', '7', '8']))));
		const setfw = () => new Promise((resolve) => resolve(dispatch(Cases.setFilterWishlist(''))));
		setft().then(() => setfte().then(() => setfst().then(() => setfs().then(() => setfstatus().then(() => setfw().then(() => {
			dispatch(Cases.searchCases({ searchStr: cases.searchStr, isWishlisted: true }));
		}))))));
	}

	const siteInList = (site: Cases.siteListState, list: Cases.siteListState[]): boolean => {
		for (const s of list) {
			if (s.site === site.site && s.siteid === site.siteid) {
				return true;
			}
		}
		return false;
	}
	const getCaseSites = (): Cases.siteListState[] => {
		let sl: Cases.siteListState[] = [];
		for (const c of cases.cases) {
			let s = { siteid: (c.siteid ? c.siteid : null), site: (c.site ? c.site : "Unassigned") };
			if (!siteInList(s, sl)) {
				sl.push(s);
			}
		}
		sl.sort(compareSite);

		return sl;
	}
	const handlePageChange = (isIncrement: boolean) => {
		if (isIncrement && cases.skip + 1 >= Math.ceil(wishlistCases.length / cases.rowsPerPage)) {
			return;
		} else if (!isIncrement && cases.skip - 1 < 0) {
			return;
		} else {
			if (!cases.isLoading) {
				dispatch(Cases.setSkip((isIncrement ? cases.skip + 1 : cases.skip - 1).toString()));
			}
		}
	}
	const handleRowsPerPage = (e: React.ChangeEvent<HTMLSelectElement>) => {
		if (!cases.isLoading) {
			dispatch(Cases.setSkip('0'));
			dispatch(Cases.setRowsPerPage(e.target.value));
		}
	}
	function compareSite(a: Cases.siteListState, b: Cases.siteListState) {
		if (!a.siteid) { return -1; }
		if (!b.siteid) { return 1; }
		if (a.site.trim() < b.site.trim()) {
			return -1;
		}
		if (a.site.trim() > b.site.trim()) {
			return 1;
		}
		return 0;
	}

	useEffect(() => {
		dispatch(Cases.searchCases({ searchStr: "", isWishlisted: true }));
	}, [])

	useEffect(() => {
		dispatch(Cases.setSkip('0'));
		dispatch(Cases.setRowsPerPage('50'));
		const wishlistCases = cases.cases.filter((item: Cases.caseListState) => (item.visible && item.wishlisted));
		setWishlistCases(wishlistCases);
	}, [cases.cases]);

	return (
		<div>
			<div style={{ position: 'absolute', top: 96, left: 0, right: 0, bottom: 80 }}>
				<div className='OrangeBand'>
					<div style={{ marginLeft: 'calc(10% + 144px)', marginRight: '10%', width: 'calc(80% - 144px)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
						<div style={{ display: 'flex', alignItems: 'center' }}>
							<img style={{ width: 96, height: 96, marginRight: 8 }} src={icon_wishlist} alt='Wishlist-Icon' />
							<div style={{ marginLeft: 24 }}>
								<div style={{ fontFamily: 'OpenSans-Bold', fontSize: 36, marginBottom: 12, whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Your Wishlist</div>
							</div>
						</div>
						<SearchCases />
					</div>
				</div>
				<div style={{ display: 'flex', alignItems: 'center', width: '100%', backgroundColor: 'white', color: 'black', fontSize: 12 }}>
					<div style={{ padding: '0 8px' }}>Filter by Team:</div>
					<div className='flexGrow2'>
						<select className='WhiteOnOrange' value={cases.filterTeam} onChange={(e) => doTeamOnChange(e)}>
							<option value=''>All Teams</option>
							{cases.teams.map((item: Cases.teamState) => {
								return (
									<option key={item.handler} value={item.handler}> {item.teamname} ({item.name})</option>
								)
							})}
						</select>
					</div>
					<div style={{ padding: '0 8px' }}>Filter by Type:</div>
					<div className='flexGrow2'>
						<select className='WhiteOnOrange' value={cases.filterType} onChange={(e) => doTypeOnChange(e)}>
							<option value=''>All Cases</option>
							<option value='Purchase'>Purchase</option>
							<option value='Remortgage'>Remortgage</option>
							<option value='Sale'>Sale</option>
							<option value='SecuredLending'>Secured Lending</option>
						</select>
					</div>
					<div style={{ padding: '0 8px' }}>Filter by Site:</div>
					<div className='flexGrow2'>
						<select className='WhiteOnOrange' value={cases.filterSite} onChange={(e) => doSiteOnChange(e)}>
							<option value=''>All Sites</option>
							{getCaseSites().map((item: Cases.siteListState) => {
								return (
									<option key={item.siteid} value={(item.siteid ? item.siteid : '<null>')}>{item.site}</option>
								)
							})}
						</select>
					</div>
					<div style={{ padding: '0 8px' }}>Filter by Status:</div>
					<div className='flexGrow2'>
						<select className='WhiteOnOrange' value={cases.filterStage} onChange={(e) => doStageOnChange(e)}>
							<option value=''>All Cases</option>
							<option value='1'>On-Boarding Complete</option>
							<option value='2'>Reporting/Title Checking/Contracts Complete</option>
							<option value='3'>Pre-Exchange/Financing/Dealing With Enquiries Complete</option>
							<option value='4'>Pre-Completion/Completing Complete</option>
						</select>
					</div>
					<div style={{ padding: '0 8px' }}>Clear Filter:</div>
					<img style={{ width: 20, marginRight: 8 }} src={clear_filter} onClick={() => clearFilters()} alt='Clear-Filter' />
				</div>
				<div style={{ backgroundColor: 'white' }}>
					<div className="row100">
						<div className="row100">
							<div className="flexGrow1 TabHeaderLeft" style={{ display: 'flex', justifyContent: 'space-between', overflow: 'hidden', textOverflow: 'ellipsis' }} onClick={() => actionOnClick({ type: 'Reference' })}>
								<div style={{ display: 'flex', justifyContent: 'space-between', marginLeft: 8, marginRight: 8, width: '100%', alignItems: 'center' }}>
									<div>Reference</div>
									{cases.sortType.type === 'Reference' && !cases.sortType.reverse &&
										<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretUp}></FontAwesomeIcon>
									}
									{cases.sortType.type === 'Reference' && cases.sortType.reverse &&
										<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretDown}></FontAwesomeIcon>
									}
								</div>
							</div>
							<div className="flexGrow1 TabHeaderCenter" style={{ display: 'flex', justifyContent: 'space-between', overflow: 'hidden', textOverflow: 'ellipsis' }} onClick={() => actionOnClick({ type: 'Type' })}>
								<div style={{ display: 'flex', justifyContent: 'space-between', marginLeft: 8, marginRight: 8, width: '100%', alignItems: 'center' }}>
									<div>Type</div>
									{cases.sortType.type === 'Type' && !cases.sortType.reverse &&
										<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretUp}></FontAwesomeIcon>
									}
									{cases.sortType.type === 'Type' && cases.sortType.reverse &&
										<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretDown}></FontAwesomeIcon>
									}
								</div>
							</div>
							<div className="flexGrow1 TabHeaderCenter" style={{ display: 'flex', justifyContent: 'space-between', overflow: 'hidden', textOverflow: 'ellipsis' }} onClick={() => actionOnClick({ type: 'Opened' })}>
								<div style={{ display: 'flex', justifyContent: 'space-between', marginLeft: 8, marginRight: 8, width: '100%', alignItems: 'center' }}>
									<div>Opened</div>
									{cases.sortType.type === 'Opened' && !cases.sortType.reverse &&
										<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretUp}></FontAwesomeIcon>
									}
									{cases.sortType.type === 'Opened' && cases.sortType.reverse &&
										<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretDown}></FontAwesomeIcon>
									}
								</div>
							</div>
							<div className="flexGrow2 TabHeaderCenter" style={{ display: 'flex', justifyContent: 'space-between', overflow: 'hidden', textOverflow: 'ellipsis' }} onClick={() => actionOnClick({ type: 'Name' })}>
								<div style={{ display: 'flex', justifyContent: 'space-between', marginLeft: 8, marginRight: 8, width: '100%', alignItems: 'center' }}>
									<div>Name</div>
									{cases.sortType.type === 'Name' && !cases.sortType.reverse &&
										<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretUp}></FontAwesomeIcon>
									}
									{cases.sortType.type === 'Name' && cases.sortType.reverse &&
										<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretDown}></FontAwesomeIcon>
									}
								</div>
							</div>
							<div className="flexGrow2 TabHeaderCenter" style={{ display: 'flex', justifyContent: 'space-between', overflow: 'hidden', textOverflow: 'ellipsis' }} onClick={() => actionOnClick({ type: 'Site' })}>
								<div style={{ display: 'flex', justifyContent: 'space-between', marginLeft: 8, marginRight: 8, width: '100%', alignItems: 'center' }}>
									<div>Site</div>
									{cases.sortType.type === 'Site' && !cases.sortType.reverse &&
										<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretUp}></FontAwesomeIcon>
									}
									{cases.sortType.type === 'Site' && cases.sortType.reverse &&
										<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretDown}></FontAwesomeIcon>
									}
								</div>
							</div>
							<div className="flexGrow3 TabHeaderCenter" style={{ display: 'flex', justifyContent: 'space-between', overflow: 'hidden', textOverflow: 'ellipsis' }} onClick={() => actionOnClick({ type: 'Address' })}>
								<div style={{ display: 'flex', justifyContent: 'space-between', marginLeft: 8, marginRight: 8, width: '100%', alignItems: 'center' }}>
									<div>Address</div>
									{cases.sortType.type === 'Address' && !cases.sortType.reverse &&
										<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretUp}></FontAwesomeIcon>
									}
									{cases.sortType.type === 'Address' && cases.sortType.reverse &&
										<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretDown}></FontAwesomeIcon>
									}
								</div>
							</div>
							<div className="flexGrow1 TabHeaderCenter" style={{ display: 'flex', justifyContent: 'space-between', overflow: 'hidden', textOverflow: 'ellipsis' }} onClick={() => actionOnClick({ type: 'Wishlist' })}>
								<div style={{ display: 'flex', justifyContent: 'space-between', marginLeft: 8, marginRight: 8, width: '100%', alignItems: 'center' }}>
									<div>Wishlist</div>
									{cases.sortType.type === 'Wishlist' && !cases.sortType.reverse &&
										<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretUp}></FontAwesomeIcon>
									}
									{cases.sortType.type === 'Wishlist' && cases.sortType.reverse &&
										<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretDown}></FontAwesomeIcon>
									}
								</div>
							</div>
							<div className="flexGrow1 TabHeaderRight" style={{ display: 'flex', justifyContent: 'space-between', overflow: 'hidden', textOverflow: 'ellipsis' }} onClick={() => actionOnClick({ type: 'Progress' })}>
								<div style={{ display: 'flex', justifyContent: 'space-between', marginLeft: 8, marginRight: 8, width: '100%', alignItems: 'center' }}>
									<div>Progress</div>
									{cases.sortType.type === 'Progress' && !cases.sortType.reverse &&
										<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretUp}></FontAwesomeIcon>
									}
									{cases.sortType.type === 'Progress' && cases.sortType.reverse &&
										<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretDown}></FontAwesomeIcon>
									}
								</div>
							</div>
						</div>
					</div>
				</div>
				<div style={{ position: 'absolute', top: 227, left: 0, right: 0, bottom: 1, overflowY: 'scroll', height: 'calc(100vh - 454px)' }} onScroll={handleScroll}>
					{wishlistCases?.map((item: Cases.caseListState, index: number) => (
						(index >= (cases.skip * cases.rowsPerPage) && index < ((cases.skip + 1) * cases.rowsPerPage)) && <CaseListItem key={item.caseno} {...item} />
					))}
				</div>
				<div style={{ position: "absolute", bottom: 0, right: 30, width: "100%", backgroundColor: "white", display: "flex", justifyContent: "flex-end", height: '51px' }}>
					<div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: '20px', padding: "0 16px", color: "#000", width: "320px" }}>
						<div style={{ display: "flex", whiteSpace: "nowrap", alignItems: "Center", gap: "10px", position: 'relative', cursor: cases.isLoaded ? 'pointer' : 'not-allowed' }}>Rows Per Page:
							<select value={cases.rowsPerPage} onChange={handleRowsPerPage} className='WhiteOnOrange' style={{ height: '30px', width: '100px', textAlign: 'center', cursor: cases.isLoaded ? 'pointer' : 'not-allowed' }} disabled={!cases.isLoaded}>
								<option value={20}>20</option>
								<option value={50}>50</option>
								<option value={100}>100</option>
								<option value={200}>200</option>
							</select>
							<div className="rowsPerPageArrow arrow right"></div>
						</div>

						<div className='paginationRightContainer'>
							<div style={{ whiteSpace: 'nowrap' }}>{cases.skip + 1} of {Math.ceil(wishlistCases.length / cases.rowsPerPage)}</div>
							<div style={{ display: "flex", gap: "16px" }}>
								<span style={{ opacity: cases.skip - 1 < 0 ? "0.3" : 1, cursor: cases.isLoaded ? 'pointer' : 'not-allowed' }} className="arrow left" onClick={() => handlePageChange(false)}></span>
								<span style={{ opacity: cases.skip + 1 >= Math.ceil(wishlistCases.length / cases.rowsPerPage) ? "0.3" : 1, cursor: cases.isLoaded ? 'pointer' : 'not-allowed' }} className='arrow right' onClick={() => handlePageChange(true)}></span>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className='mainFooter'>
				<div style={{ marginLeft: '10%', marginRight: '10%', width: '80%', marginTop: 18 }}>
					<img style={{ height: 28 }} src={leading_the_way} alt='LeadingTheWay-Banner' />
				</div>
			</div>
			<div className='loginFooter'></div>
			<NavMenu />
			<NavBar />
		</div>
	);
}

export default WishList;